export default __webpack_public_path__ + "static/media/8c03b284b195c24b.41c5c97e467fc342daa2b63798e329b9.svg";